
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[username]/donations",
      function () {
        return require("private-next-pages/user/[username]/donations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[username]/donations"])
      });
    }
  